<div class="pagina-404">
  <div id="container" class="cls-container checkout">
    <div id="container" class="cls-container">
      <form (ngSubmit)="submit($event)" class="cls-content">
        <h1 class="error-code text-info">404</h1>
        <div class="panel col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <div class="panel-body">
            <p class="text-main text-semibold text-center margin-auto">Transação não encontrada</p>
            <div class="pad-btm text-muted">
              O código da transação não foi informado ou está incorreto.
            </div>
            <div class="row mar-ver mb-30">
              <div class="col-xs-12 col-sm-10 col-sm-offset-1">
                <input [(ngModel)]="tokenId" type="text" name="id" placeholder="Insira o código..." class="form-control input-lg error-search">
              </div>
            </div>
            <div class="row mar-ver">
              <div class="col-xs-12 col-sm-10 col-sm-offset-1">
                <button type="submit" class="btn btn-success btn-confirmar">Tentar novamente</button>
              </div>
            </div>
            <div class="mt-30"><a class="btn-link" [routerLink]="['/login']">Ir para o painel</a></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>